export const createWorkerFunc = () => {
    const temp = self;
    let timer = null;

    function startInterval(config) {
        destroyInterval();
        timer = setInterval(
            () => doFetch(config),
            60000
        );
    };

    function destroyInterval() {
        timer && clearInterval(timer);
        timer = null;
    };

    const doFetch = (config) => {
        const { url, timestamp, authorization } = config;
        fetch && fetch(url, {
            method: 'GET',
            mode: 'cors',
            credentials: 'include',
            headers: new Headers({
                'Content-Type': 'application/json',
                Timestamp: timestamp,
                Authorization: authorization
            })
        }).then(res => {
            if (!res.ok) {
                const {status, statusText} = res;
                const errorInfo = JSON.stringify({status, statusText});
                throw new Error('fetch error 1:' + errorInfo);
            }
            return res.json();
        }).then(response => {
            if (!response) return;
            const {code, data, msg} = response;
            if (code === 0 && data) {
                temp.postMessage({ type: 'success', data: Object.assign({}, data, config) });
            } else {
                if (msg !== 'msn.backendMsg.noPermission') {
                    temp.postMessage({ type: 'fail', msg: 'res error msg:' + msg, data: config });
                }
            }
        }).catch(error => {
            temp.postMessage({ type: 'fail', msg: 'catch error:' + String(error), data: config });
        });
    };

    temp.onmessage = (event) => {
        if (event?.data) {
            const {action, config} = event.data;
            config.action = action;
            if (action === 'init') {
                doFetch(config);
            } else if (action === 'start') {
                startInterval(config);
            } else {
                destroyInterval();
            }
        }
    };
};


